import React from 'react';
import PropTypes from 'prop-types';
import AdvForm from '../../../CommonComponents/AdvForm';
import {
  simpleSelectDefaultValue,
  simpleSelectChangedToNonNull,
} from '../../../Profile/Accounts_react/AccountsUtils';
import { isNumeric, createCustomPropType, isUuid } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';

const View = ({
  clientId,
  title,
  groupTitle,
  areOptionsLoaded,
  goalId,
  whatIfType,
  storeData,
  hasSpouse,
  principalName,
  spouseName,
  survivorLivingExpensesOptions,
  spouseSurvivorLivingExpenses,
  principalSurvivorLivingExpenses,
}) => (
  <div className="what-ifs-layout-content">
    <h4 className="what-if-group-title">{groupTitle}</h4>
    <AdvForm>
      <ValidationErrors clientId={clientId} />
      <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
        <li className="what-ifs-form-field">
          <h5 className="what-if-title">{title}</h5>
        </li>
        <li className="what-ifs-form-field">
          <div className="what-ifs-insurance-label">
            <Select
              label={principalName}
              id="PrincipalSurvivorLivingExpenses"
              value={simpleSelectDefaultValue(
                survivorLivingExpensesOptions,
                principalSurvivorLivingExpenses,
              )}
              onChange={simpleSelectChangedToNonNull(
                clientId,
                storeData(goalId, whatIfType),
                'WhatIf.PrincipalSurvivorLivingExpenses',
              )}
              options={survivorLivingExpensesOptions}
            />
          </div>
        </li>
        {hasSpouse && (
          <li className="what-ifs-form-field">
            <div className="what-ifs-insurance-label">
              <Select
                label={spouseName}
                id="SpouseSurvivorLivingExpenses"
                value={simpleSelectDefaultValue(
                  survivorLivingExpensesOptions,
                  spouseSurvivorLivingExpenses,
                )}
                onChange={simpleSelectChangedToNonNull(
                  clientId,
                  storeData(goalId, whatIfType),
                  'WhatIf.SpouseSurvivorLivingExpenses',
                )}
                options={survivorLivingExpensesOptions}
              />
            </div>
          </li>
        )}
      </ul>
    </AdvForm>
  </div>
);
View.defaultProps = {
  title: '',
  groupTitle: '',
  spouseName: '',
  spouseSurvivorLivingExpenses: 100,
};

View.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  whatIfType: PropTypes.number.isRequired,
  storeData: PropTypes.func.isRequired,
  hasSpouse: PropTypes.bool.isRequired,
  principalName: PropTypes.string.isRequired,
  spouseName: PropTypes.string,
  spouseSurvivorLivingExpenses: PropTypes.number,
  survivorLivingExpensesOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  principalSurvivorLivingExpenses: PropTypes.number.isRequired,
};

export default View;
